import { render } from "./NewClienteView.vue?vue&type=template&id=3b856702"
import script from "./NewClienteView.vue?vue&type=script&lang=js"
export * from "./NewClienteView.vue?vue&type=script&lang=js"

import "./NewClienteView.vue?vue&type=style&index=0&id=3b856702&lang=css"

import exportComponent from "D:\\laragon\\www\\balkum-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__